import classNames from "classnames";
import React from "react";
import styles from "../statics/styles/toggle.scss";
const Toggle = ({ checked, onChange, dataHook }) => {
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      className: styles.toggle_input_root,
      onClick: onChange,
      tabIndex: -1,
      onKeyPress: void 0,
      role: "button",
      "data-hook": dataHook
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames(styles.toggle_input_container, {
          [styles.toggle_input_container_checked]: checked
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: styles.toggle_switch }, /* @__PURE__ */ React.createElement(
        "span",
        {
          className: classNames(styles.toggle_track, {
            [styles.toggle_track_checked]: checked
          })
        }
      ), /* @__PURE__ */ React.createElement(
        "span",
        {
          className: classNames(
            styles.toggle_slider,
            checked ? styles.toggle_slider_checked : styles.toggle_slider_unchecked
          )
        }
      ))
    )
  );
};
var Toggle_default = Toggle;
export {
  Toggle_default as default
};
//# sourceMappingURL=Toggle.js.map
